import axios from "axios";
import { getApiUrl } from "@/Utils/api-url-helper";

/**
 * @typedef {Object} CurseItem
 * @property {string} title - El título del curso.
 * @property {string} description - La descripción del curso.
 * @property {string} status - El estado del curso.
 * @property {boolean} disabled - Indica si el curso está desactivado.
 * @property {string} icon - El enlace al icono del curso.
 * @property {string} id - El ID del curso.
 */

/**
 * @typedef {Object} ModuleItem
 * @property {string} label - La etiqueta del elemento.
 * @property {string} id - El ID del elemento.
 * @property {string} course_count - Cantidad de cursos en el módulo.
 * @property {Array<CurseItem>} courses - Cursos del módulo.
 */

/**
 * Obtiene los módulos en los que el usuario está matriculado (información mínima, sin progreso),
 * ordenados por último uso.
 * @returns {Promise.<Array<ModuleItem>>} Lista de elementos del curso
 */
export async function getEnrolledModules() {
  const apiBaseUrl = getApiUrl(import.meta.env.VITE_API_BASE_URL);
  return axios
    .get(`${apiBaseUrl}/api/modules/enrolled`)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

/**
 * Obtiene el porcentaje de progreso por módulo para los cursos matriculados.
 * @returns {Promise.<Array<{ moduleId: number, progressPercentage: number|null }>>}
 */
export async function getEnrolledModulesProgress() {
  const apiBaseUrl = getApiUrl(import.meta.env.VITE_API_BASE_URL);
  return axios
    .get(`${apiBaseUrl}/api/modules/enrolled/progress`)
    .then((response) => response.data)
    .catch((err) => {
      console.error(err);
      return [];
    });
}

/**
 * Obtiene los módulos en los que el usuario NO está matriculado,
 * ordenados por popularidad (más popular primero).
 * @returns {Promise.<Array<ModuleItem>>} Lista de elementos del curso
 */
export async function getAvailableModules() {
  const apiBaseUrl = getApiUrl(import.meta.env.VITE_API_BASE_URL);
  return axios
    .get(`${apiBaseUrl}/api/modules/available`)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}
